import {context} from "../constants/context";
import {halClient} from "../hal";
import {BBModel} from "../bb_model";
import sessionStorage from "../utils/storage/session_storage";
import localStorage from '../utils/storage/local_storage';

const memberLogin = {
    login(form, options) {
        return new Promise((resolve, reject) => {
            let url = `${context.apiUrl}/api/${context.apiVersion}/login`;
            if (options.company_id != null) {
                url = `${url}/member/${options.company_id}`;
            }
            halClient.$post(url, options, form).then((login) => {
                    if (login.$has('member')) {
                        return login.$get('member').then((member) => {
                            member = new BBModel.Member.Member(member);
                            const auth_token = member._data.getOption('auth_token');
                            sessionStorage.setItem('login', member.$toStore());
                            localStorage.setItem('auth_token', auth_token);
                            return resolve(member);
                        });
                    } else if (login.$has('members')) {
                        return resolve(login);
                    } else {
                        return reject('No member account for login');
                    }
                }
                , (err) => {
                    if (err.status === 400) {
                        const login = halClient.$parse(err.data);
                        if (login.$has('members')) {
                            return resolve(login);
                        } else {
                            return reject(err);
                        }
                    } else {
                        return reject(err);
                    }
                }
            );
        });
    }
};

export {
    memberLogin
}
